import React, { FC } from 'react';
import Toast from 'react-native-toast-message';
import toastConfig from './ToastGlobalConfig';

const ToastRoot: FC = () => <Toast config={toastConfig} />;

export default ToastRoot;
